<template>
  <div>

  </div>
 
</template>

<script>
import appsettings from '@/store/app-settings'
const axios = require('axios');

const url = appsettings.OAuthLogin + 'api/AuthToken';
const params = new URLSearchParams()
params.append('client_id', 'FE4FC3BC-287F-400D-2770-08D7C4BA67BA')
params.append('client_secret', 'FE4FC3BC-287F-4E2D-2770-08D7C4BA67FF')
params.append('grant_type','authorization_code')
//params.append('redirect_uri', 'http://localhost:8080')

const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization':'Basic '+ this.$route.query.code
  }
}
// const code = this.$route.query.code;
// const token_type = this.$route.query.token_type;
// const expires_in = this.$route.query.expires_in;

export default {
    created: function () {          
        axios.post(url, params, config)
            .then((result) => {
            // Do somthing
                console.log(result)
            })
            .catch((err) => {
            // Do somthing
            console.log(err)
            })
        },
    methods: {          

    }
}
</script>

<style lang="scss">
</style>
